import React from 'react';
import './styles/Anmeldung.css';
import {Link} from 'react-router-dom';

function AnmeldungSucess() {
  return (
    <div className='anmeldungContainer'>
        <div className='anmeldungContentContainer'>
            <div className='anmeldungTextContainer'>
                <h1>Anmeldung erfolgreich!</h1>
                <p>Vielen Dank für deine Anmeldung! Du erhälst in Kürze eine Bestätigung per E-Mail.</p>
                <Link to='/'>Zur Startseite</Link>
            </div>
        </div>
        <div className='bottomContainer'>
                <Link to='https://deutsche-schreberjugend.de/'>
                    <p> Deutsche Schreberjugend</p>
                </Link>
                <Link to={'/impressum'}>
                    <p>Impressum</p>
                </Link>
                <Link to={'/datenschutz'}>
                    <p>Datensschutz</p>
                </Link>
            </div>
    </div>
  )
}

export default AnmeldungSucess